import React, { useEffect } from 'react';
import { isRouteErrorResponse, useRouteError } from 'react-router-dom';

import errorReporter from '../../services/errorReporter.js';
import Error404Page from '../../Pages/Error404Page/Error404Page.js';
import { ErrorScreen } from './ErrorBoundary.js';
import { shouldReloadForChunk } from './chunkReload.js';

function RouteError({ inline }) {
  const error = useRouteError();
  const notFound = isRouteErrorResponse(error) && error.status === 404;

  useEffect(() => {
    if (notFound) return;
    if (shouldReloadForChunk(error)) {
      window.location.reload();
      return;
    }
    errorReporter.report({
      message: error?.message || error?.statusText || String(error),
      stack: error?.stack || null,
      metadata: { type: 'route_error', status: error?.status ?? null },
    });
    errorReporter.flush();
  }, [error, notFound]);

  if (notFound) return <Error404Page />;
  return <ErrorScreen error={error} inline={inline} />;
}

export default RouteError;
